import { Box, Grid, Theme, Typography, useMediaQuery } from '@mui/material';
import { Icon24InfoBgcFilled } from '@care/react-icons';
import { useState } from 'react';
import { AmplitudeEvent, trackAmplitudeEvent, SeoFeatureInteracted } from '@/lib/analyticsHelper';
import { SafetyModalWrapper } from './SafetyModalWrapper';

const BackgroundCheckBanner = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const handleBackgroundCheck = () => {
    setOpenModal(true);

    const amplitudeData: SeoFeatureInteracted = {
      feature_name: 'background check banner',
    };

    trackAmplitudeEvent(AmplitudeEvent.seoFeatureInteracted, amplitudeData);
  };

  return (
    <Grid item xs={12}>
      <Box
        component="button"
        p={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        color="care.grey.900"
        mt={-2}
        border="none"
        sx={(theme) => ({
          height: '60px',
          backgroundColor: theme.palette.care.blue[100],
          fontWeight: 700,
          '&:hover': {
            cursor: 'pointer',
          },
        })}
        onClick={handleBackgroundCheck}
        tabIndex={0}>
        <Box component="span" display="inline-block" mr={0.5}>
          <Icon24InfoBgcFilled size="30px" />
        </Box>
        <Typography component="span" variant={isMobile ? 'h5' : 'h3'}>
          All caregivers are background checked.&nbsp;
          <Box component="span" borderBottom={2}>
            See more
          </Box>
        </Typography>
      </Box>
      <SafetyModalWrapper openModal={openModal} setOpenModal={setOpenModal} />
    </Grid>
  );
};

export default BackgroundCheckBanner;
